import type {ReminderWeekday} from '../../domain/reminder-weekday.value-object';
import type {Result, UseCase} from 'framework';
import type {SettingsError} from '../../domain/errors';
import type {
  ReminderScheduleInterval,
  ReminderKind,
  UserReminder,
} from '../../domain/user-reminder';
import type {SettingsRepository} from '../ports/settings.repository';

export type UpdateReminderInput = {
  readonly kind: ReminderKind;
  readonly interval?: ReminderScheduleInterval;
  readonly weekdays?: readonly ReminderWeekday[];
  readonly enabled?: boolean;
};

export class UpdateReminder implements UseCase<[UpdateReminderInput], UserReminder> {
  constructor(private readonly repository: SettingsRepository) {}

  execute(input: UpdateReminderInput): Promise<Result<UserReminder, SettingsError>> {
    return this.repository.updateReminder(input.kind, {
      interval: input.interval,
      weekdays: input.weekdays,
      enabled: input.enabled,
    });
  }
}
